
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class extends Vue {
  @Prop() private activeIndex!: string
  // private activeIndex = '5'
  private menus = [
    { id: '1', title: '首页', url: 'index.html', status: false },
    { id: '11', title: '新闻公告', url: 'detailPage.html', status: false },
    { id: '10', title: '关于我们', url: 'detailPage.html', status: false },
    { id: '12', title: '组织机构', url: 'detailPage.html', status: false },
    { id: '13', title: '技能提升', url: 'detailPage.html', status: false },
    { id: '14', title: '技术创新', url: 'detailPage.html', status: false },
    { id: '15', title: '技术服务', url: 'detailPage.html', status: false },
    { id: '16', title: '成果评审', url: 'detailPage.html', status: false },
    { id: '17', title: '会员服务', url: 'detailPage.html', status: false },
    { id: '18', title: '战略伙伴', url: 'detailPage.html', status: false },
    { id: '19', title: '政策法规', url: 'detailPage.html', status: false },
    { id: '20', title: '党建工作', url: 'detailPage.html', status: false }
  ]

  mounted () {
    console.log(this.activeIndex)
  }

  jump (item: any, index: number) {
    window.location.href = `${item.url}?menuId=${item.id}/?index=${index}`
  }
}
